import { ICustomer } from "../../../@types/customer.type";



export const includeCustomFieldsfromApi = (customer:ICustomer) => {

  const customFieldsObject = Array.isArray(customer.customFields)
  ? Object.fromEntries(
      customer.customFields.map(({ key, value }) => [key, value])
    )
  : {};

  return {
    ...customer,
    customFieldsObject,
    customFields: undefined,
  }
}


export const includeCustomFieldstoApi = (customer:ICustomer, formDataCustomFields: Record<string, any>) => {

  const customFields = Object.entries(formDataCustomFields).map(([key, value]) => ({ key, value: value !== null ? String(value) : value })); 

  return {
    ...customer,
    customFields,
  }
}
